import React from "react";
import PropTypes from "prop-types";
import * as Icons from "react-icons/fa";

export function Button({
  text,
  onClick = () => {},
  className = "",
  disabled = false,
  variant = "primary",
  size = "md",
  type,
  iconName = null,
}) {
  // Define base styles
  const baseStyles =
    "btn inline-flex items-center justify-center font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2";

  // Define variant styles
  const variantStyles = {
    primary: "bg-violet-600 hover:bg-violet-800 text-white hover:bg-gray-200",
    transparent:
      "bg-transparent text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-900 border border-gray-200 dark:border-gray-700",
    secondary: "bg-gray-500 text-white hover:bg-gray-600 focus:ring-gray-500",
    danger: "bg-red-500 text-white hover:bg-red-600 focus:ring-red-500",
    success: "bg-green-500 text-white hover:bg-green-600 focus:ring-green-500",
    white:
      "bg-white text-gray-800 border border-gray-200 hover:bg-gray-100 focus:ring-gray-500",
  };

  // Define size styles
  const sizeStyles = {
    sm: "px-2.5 py-1.5 text-xs",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
  };

  // Get the icon component from react-icons
  const IconComponent = iconName ? Icons[iconName] : null;

  return (
    <button
      onClick={onClick}
      type={type ? type : ""}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
      disabled={disabled}
    >
      {IconComponent && <IconComponent className="mr-2" />}
      {text}
    </button>
  );
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "danger",
    "success",
    "white",
    "transparent",
  ]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  iconName: PropTypes.string,
};